import { createAction, createRequestConst } from 'util/actions';

const initialState = { open: true, show: true };
export const name = 'recentFsps';

export const TOGGLE = createRequestConst(name);

export const toggle = createAction(TOGGLE);

export const selector = (state) => state[name];

export default (state = initialState, { data, type }) => {
  switch (type) {
    case TOGGLE.ACTION:
      return { ...state, open: data };

    default:
      return state;
  }
};
